// extracted by mini-css-extract-plugin
export default {"link":"HeaderFooterLink_link__JSnri"};